import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
html {
	overflow: hidden;
}
 body{
	margin: 0;
	
 }
 body, html {
	scrollbar-width: thin;
 }


  /* Default vertical & horizontal thickness */
  :root {
    --scrollbar-size: 6px;
    --scrollbar-thumb: #9aa0a6;   /* neutral grey */
    --scrollbar-thumb-hover: #80868b;
    --scrollbar-track: transparent;
	 scrollbar-width: thin;
  }

  /* Global scrollbars */
  ::-webkit-scrollbar {
    width: var(--scrollbar-size);
    height: var(--scrollbar-size);
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-thumb-hover);
  }
  ::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
  }

  /* Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  }
`;

export default GlobalStyles;
